import { StyledTutorialKeys } from "../TutorialKeys.styled"

export const TutorialCombos = () => {
  return (<StyledTutorialKeys>
    <div className="key-definition">
      <div className="key">
        <div className="tutorial-key"><i>Q</i></div>
        <span className="key-combo">→</span>
        <div className="tutorial-key"><i>Q</i></div>
        <span className="key-combo">→</span>
        <div className="tutorial-key"><i>Q</i></div>
      </div>
      <div className="key-action">2-3 Punch Combo</div>
    </div>
    <div className="key-definition">
      <div className="key">
        <div className="tutorial-key"><i>E</i></div>
        <span className="key-combo">→</span>
        <div className="tutorial-key"><i>E</i></div>
        <span className="key-combo">→</span>
        <div className="tutorial-key"><i>E</i></div>
      </div>
      <div className="key-action">2-3 Kick Combo</div>
    </div>
    <div className="key-definition">
      <div className="key">
        <div className="tutorial-key"><i>Q</i></div>
        <span className="key-combo">→</span>
        <div className="tutorial-key"><i>E</i></div>
        <span className="key-combo">→</span>
        <div className="tutorial-key"><i>E</i></div>
      </div>
      <div className="key-action">Punch / Kick / Kick Combo</div>
    </div>
    <div className="key-definition">
      <div className="key">
        <div className="tutorial-key"><i>E</i></div>
        <span className="key-combo">→</span>
        <div className="tutorial-key"><i>Q</i></div>
        <span className="key-combo">→</span>
        <div className="tutorial-key"><i>Q</i></div>
      </div>
      <div className="key-action">Kick / Punch / Punch Combo</div>
    </div>
  </StyledTutorialKeys>)
};
